<template>
	<div class="chat container">
		<h2 class="center teal-text">Ninja Chat</h2>

		<div class="card">
			<div class="card-content">
				<ul class="messages" v-chat-scroll>
					<li v-for="message in messages" :key="message.id">
						<span class="teal-text">{{ message.name }}</span>
						<span class="grey-text text-darken-3">{{ message.content }}</span>
						<span class="grey-text time">{{ message.timestamp }}</span>
					</li>
				</ul>
				<NewMessage :name="name" />
			</div>
		</div>
	</div>
</template>

<script>
import NewMessage from '@/components/NewMessage'
import db from '@/firebase/init'
import moment from 'moment'

export default {
	nme: "Chat",
	props: { name },
	components: { NewMessage },
	data() {
		return {
			messages: []
		}
	},
	created() {
		const ref = db.collection("messages").orderBy('timestamp')

		ref.onSnapshot(snapshot => {
			snapshot.docChanges().forEach(change => {
				if (!change.type == "added")
					return

				const doc = change.doc
				const data = doc.data()
				this.messages.push({
					id: doc.id,
					name: data.name,
					content: data.content,
					timestamp: moment(data.timestamp).format("lll")
				})
			})
		})
	}
}
</script>

<style>
.chat {
	max-width: 600px;
}

.chat h2 {
	font-size: 2.6em;
	margin-bottom: 40px;
}

.chat span {
	font-size: 1.4em;
}

.chat .time {
	display: block;
	font-size: 1.2em;
}

.messages {
	word-wrap: break-word;
	max-height: 300px;
	overflow: auto;
}

.messages::-webkit-scrollbar {
	width: 3px;
}

.messages::-webkit-scrollbar-track {
	background: #ddd;
}

.messages::-webkit-scrollbar-thumb {
	background: #aaa;
}
</style>


// WEBPACK FOOTER //
// src/components/Chat.vue